/**
* Invoice
*/

class Invoice {

    constructor(document) {
        const data = document.data()

        this.uid = document.id
        this.createdAt = data.createdAt
        this.title = data.title;
        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.invoiceID = data.invoiceID;
        this.freeTransport = data.freeTransport ? data.freeTransport : false;
        this.address = {
            address: data.address.address ? data.address.address : '',
            zipCode: data.address.zipCode ? data.address.zipCode : '',
            city: data.address.city ? data.address.city : '',
            country: data.address.country ? data.address.country : ''
        }
        this.deliveries = data.deliveries
        this.department = data.department;
        this.amount = data.amount
        this.status = data.status
        this.phoneNumber = data.phoneNumber
        this.expertUID = data.expertUID
        this.documents = data.documents
        this.remuneration = data.remuneration
        this.typeRemuneration = data.typeRemuneration ? data.typeRemuneration : ''
        this.date = data.date ? data.date : ''
        this.hours = data.hours ? data.hours : ''
        this.email = data.email
        this.sms_ids = data.sms_ids ? data.sms_ids : []
    }

    get data() {
        return {
            uid: this.uid,
            createdAt: this.createdAt,
            title: this.title,
            firstName: this.firstName,
            lastName: this.lastName,
            zipCode: this.zipCode,
            invoiceID: this.invoiceID,
            freeTransport: this.freeTransport,
            address: {
                address: this.address.address,
                zipCode: this.address.zipCode,
                city: this.address.city,
                country: this.address.country
            },
            deliveries: this.deliveries,
            amount: this.amount,
            status: this.status,
            phoneNumber: this.phoneNumber,
            expertUID: this.expertUID,
            remuneration: this.remuneration,
            typeRemuneration: this.typeRemuneration,
            date: this.date,
            hours: this.hours,
            email: this.email,
            sms_ids: this.sms_ids
        }
    }

    ID() {
        return this.invoiceID
    }

    firebaseStoragePath() {
        return "invoices/Facture-" + this.ID() + ".pdf"
    }

}

export default Invoice;